import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0223 from "../../../lesson/course-02/lesson-23/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "9899a221-dc37-4bf8-a863-0a60efc1a5ef",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0223),
    lesson: lesson0223,
  },
];

export default lessonLinks;
